import { Link } from "react-router-dom";
import HelpArticle, { type HelpArticleText } from "../HelpArticle";

// Run E2 J2 round 3: rewritten for Project Explore from the real UI, English and Spanish.

const TEXT: Record<"en" | "es", HelpArticleText> = {
  en: {
    title: "Connecting Your LMS",
    intro: "Project Explore works with Google Classroom, Clever sign-in and Canvas (LTI).",
    ordered: false,
    steps: [
      "Google Classroom: in the teacher dashboard, choose Settings. Under LMS Integration Status, choose Connect next to Google Classroom and sign in with Google. Then open Class Management and choose Sync with Google Classroom to bring in your classes and students.",
      "Clever: students and teachers can sign in with the Clever button on the login page.",
      <>
        Canvas: a school or district administrator registers Canvas in the
        admin dashboard. See the{" "}
        <Link to="/support/help-center/lti-registration-guide" className="text-indigo-700 underline">
          LTI Registration Guide
        </Link>
        .
      </>,
    ],
    tip: "If you need help with your school's LMS login, please contact your district's IT team.",
  },
  es: {
    title: "Cómo conectar tu LMS",
    intro: "Project Explore funciona con Google Classroom, con el inicio de sesión de Clever y con Canvas (LTI).",
    ordered: false,
    steps: [
      "Google Classroom: en el panel de maestro, elige Configuración. En Estado de la integración con el LMS, elige Conectar junto a Google Classroom e inicia sesión con Google. Luego abre Administrar clases y elige Sincronizar con Google Classroom para traer tus clases y tus estudiantes.",
      "Clever: los estudiantes y los maestros pueden iniciar sesión con el botón de Clever en la página para iniciar sesión.",
      <>
        Canvas: un administrador de la escuela o del distrito registra Canvas en
        el panel de administración. Consulta la{" "}
        <Link to="/support/help-center/lti-registration-guide" className="text-indigo-700 underline">
          Guía de registro LTI
        </Link>
        .
      </>,
    ],
    tip: "Si necesitas ayuda con el inicio de sesión del LMS de tu escuela, por favor comunícate con el equipo de tecnología de tu distrito.",
  },
};

export default function ConnectingYourLMS() {
  return <HelpArticle text={TEXT} />;
}
